export const ROOT = 'StepPayment/formPayment/price';

export const FETCH_PRICE_PACKAGE_REQUEST = `${ROOT}/FETCH_PRICE_PACKAGE_REQUEST`;
export const FETCH_PRICE_PACKAGE_FAILURE = `${ROOT}/FETCH_PRICE_PACKAGE_FAILURE`;
export const FETCH_PRICE_PACKAGE_SUCCESS = `${ROOT}/FETCH_PRICE_PACKAGE_SUCCESS`;
